export var Variants;

(function (Variants) {
  Variants["Informational"] = "Informational";
  Variants["Positive"] = "Positive";
  Variants["Negative"] = "Negative";
  Variants["Warning"] = "Warning";
  Variants["Highlight"] = "Highlight";
})(Variants || (Variants = {}));

export var Types;

(function (Types) {
  Types["Default"] = "Default";
  Types["Emphasis"] = "Emphasis";
  Types["Subdued"] = "Subdued";
})(Types || (Types = {}));